import React from "react";
import { Check, FileSearch, Banknote, KeyRound } from "lucide-react";
import { fmt$ } from "@/lib/format";

const STAGE_MAP = {
  earnest_money: "offer",
  general_inspection: "inspection",
  sewer_scope: "inspection", septic: "inspection", well: "inspection",
  water_quality: "inspection", pest: "inspection", roof: "inspection",
  structural_engineer: "inspection", hvac: "inspection", electrical: "inspection",
  plumbing: "inspection", mold: "inspection", radon: "inspection",
  appraisal: "processing",
  custom: "inspection",
};

const STAGES = [
  { key: "offer", icon: Check, title: "Offer Accepted", desc: "Potential earnest-money payment" },
  { key: "inspection", icon: FileSearch, title: "Inspection Period", desc: "General + optional specialty inspections" },
  { key: "processing", icon: Banknote, title: "Loan Processing", desc: "Appraisal, insurance, lender costs" },
  { key: "closing", icon: KeyRound, title: "Closing Day", desc: "Remaining cash due" },
];

export default function Timeline({ preItems = [], additionalCashAtClosing = 0 }) {
  const byStage = { offer: [], inspection: [], processing: [], closing: [] };
  for (const it of preItems) {
    const amt = Number(it.amount || 0);
    if (!amt) continue;
    const stage = STAGE_MAP[it.type] || "inspection";
    byStage[stage].push({ label: it.label, amount: amt });
  }
  if (additionalCashAtClosing > 0) {
    byStage.closing.push({ label: "Estimated remaining cash due", amount: additionalCashAtClosing });
  }

  return (
    <div data-testid="timeline" className="relative">
      <div className="grid gap-6 md:grid-cols-4">
        {STAGES.map((s) => (
          <div key={s.key} className="relative">
            <div className="flex items-start gap-3 md:flex-col md:items-start">
              <div className="flex-shrink-0 h-12 w-12 rounded-full bg-white border-2 border-brand-accent text-brand-accent flex items-center justify-center">
                <s.icon size={20} />
              </div>
              <div className="flex-1">
                <div className="font-medium text-brand-ink text-sm">{s.title}</div>
                <div className="text-xs text-brand-muted mt-0.5">{s.desc}</div>
              </div>
            </div>
            <div className="mt-3 space-y-1.5" data-testid={`timeline-stage-${s.key}`}>
              {byStage[s.key].length === 0 ? (
                <div className="text-xs text-brand-muted italic">No entries yet</div>
              ) : byStage[s.key].map((entry) => (
                <div key={`${s.key}:${entry.label}:${entry.amount}`} className="rounded-lg bg-brand-bg border border-brand-border px-3 py-2 text-xs flex justify-between gap-2">
                  <span className="text-brand-ink truncate">{entry.label}</span>
                  <span className="font-medium text-brand-ink">{fmt$(entry.amount)}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      <p className="text-xs text-brand-muted mt-6">Timing varies by transaction. This is a general planning sequence, not a schedule.</p>
    </div>
  );
}
